import styles from "./SelectBox.module.css";
const SelectBox = ({
  value,
  onChange,
  options = [],
  placeholder = "Select",
  disabled = false,
  width = "220px",
}) => {
  return (
    <div className={styles.wrapper} style={{ width }}>
      <select
        className={styles.select}
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        <option value="" disabled>
          {placeholder}
        </option>

        {options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};
export default SelectBox;
